var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("新增白名单"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 620
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("用户名"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "mobile",
      label: _vm.$t("手机号"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    model: {
      value: _vm.dataFrom.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "mobile", $$v);
      },
      expression: "dataFrom.mobile"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("归属客户"),
      prop: "customerId"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("归属客户"),
      allowClear: ""
    },
    on: {
      change: _vm.getDataFun
    },
    model: {
      value: _vm.dataFrom.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "customerId", $$v);
      },
      expression: "dataFrom.customerId"
    }
  }, _vm._l(_vm.customerList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("归属应用"),
      prop: "applicationId2"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("归属应用"),
      allowClear: "",
      disabled: _vm.dataFrom.customerId ? false : true,
      mode: "multiple"
    },
    model: {
      value: _vm.dataFrom.applicationId2,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "applicationId2", $$v);
      },
      expression: "dataFrom.applicationId2"
    }
  }, _vm._l(_vm.applicationList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.applicationId
      }
    }, [_vm._v(" " + _vm._s(item.name) + "(" + _vm._s(item.type == 1 ? "app" : item.type == 2 ? "h5" : item.type == 3 ? "pc" : _vm.$t("小程序")) + ") ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备注"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    model: {
      value: _vm.dataFrom.remark,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "remark", $$v);
      },
      expression: "dataFrom.remark"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };